// @flow

import * as React from "react";

import Footer from "@/components/Footer/Footer";
import Header from "@/components/Header/Header";

type Props = {
    headerType?: "light" | "dark",
    children?: React$Node,
};

const AppLayout = ({children, headerType}: Props): React$Element<React$FragmentType> => (
    <>
        <Header type={headerType} />

        <main>{children}</main>

        <Footer />
    </>
);

export default AppLayout;
